import { render } from "./StandardTransportOut.vue?vue&type=template&id=6449d055&scoped=true"
import script from "./StandardTransportOut.vue?vue&type=script&lang=js"
export * from "./StandardTransportOut.vue?vue&type=script&lang=js"

import "./StandardTransportOut.vue?vue&type=style&index=0&id=6449d055&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6449d055"]])

export default __exports__